<template
>
    <v-card flat>
        <v-overlay :value="loadingOnboardingData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ activeOnboarding.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark color="bal-red" class="ml-2" @click="editOnboarding" v-if="activeOnboarding.status !== 'confirmed'">
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-btn dark color="bal-red" class="ml-2" @click="handleDownloadFileClick" v-if="activeOnboarding.has_file">
                <v-icon>download</v-icon>
                {{ "Download file" | t }}
            </v-btn>
            <v-btn dark color="bal-red" class="ml-2" @click="handleConfirmClick" v-if="activeOnboarding.status === 'completed'">
                <v-icon>check</v-icon>
                {{ "Confirm" | t }}
            </v-btn>
            <v-menu offset-y bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ "Delete" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "General info" | t }}
            </v-tab>
            <v-tab-item>
                <general-info-view-tab />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Members" | t }}
            </v-tab>
            <v-tab-item>
                <members-view-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import GeneralInfoViewTab from "./tabs/general-info-view-tab";
import MembersViewTab from "./tabs/members-view-tab";

export default {
    name: "onboarding-admin-view",
    components: {GeneralInfoViewTab, MembersViewTab},
    data() {
        return {
            tab: 0,
            tabs: ["General info", "Members"],
            appUrl: null
        };
    },
    computed: {
        ...mapState('onboarding', ['activeOnboarding', 'loadingOnboardingData'])
    },
    async mounted() {
        this.appUrl = process.env.VUE_APP_URL;
        document.addEventListener("keydown", this.nextTab);
        await this.getOnboardingData(this.$route.params.onboardingId)
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    methods: {
        ...mapActions('onboarding', ['getOnboardingData', 'confirmCurrentOnboarding', 'getOnboardings', 'deleteOnboarding']),
        ...mapMutations(['setRequestSuccess']),
        ...mapActions(['getCompanies']),
        closeDrawer() {
            this.$router.push({name: "onboarding-admin-list"});
        },
        editProduct() {
            this.$router.push({
                name: "onboarding-admin-edit",
                params: {onboardingId: this.$route.params.onboardingId, tab: this.tabs[this.tab]}
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editProduct();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },
        async handleDeleteClick() {
            if (confirm("Are you sure you want to delete this onboarding?")) {
                const response = await this.deleteOnboarding(this.activeOnboarding.id)
                if (response && response.data && response.data.success === 1) {
                    await this.getOnboardings();
                    this.$router.push({name: "onboarding-admin-list"});
                }
            }
        },
        handleDownloadFileClick() {
            if (this.activeOnboarding.has_file) {
                window.location = `${this.appUrl}/app/onboarding-download-file/?onboardingId=${this.activeOnboarding.id}`;
            }
        },

        async handleConfirmClick() {
            const response = await this.confirmCurrentOnboarding(this.activeOnboarding.id)
            if (response && response.data && response.data.success === 1) {
                await this.getOnboardingData(this.activeOnboarding.id)
                await this.getOnboardings()
                await this.getCompanies()
                this.setRequestSuccess(true);
            }
        },
        editOnboarding() {
            this.$router.push({
                name: "onboarding-admin-edit",
                params: { onboardingId: this.$route.params.onboardingId, tab: this.tabs[this.tab] }
            });
        }
    }
};
</script>

<style scoped></style>
